var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"producto-view"},[_c('div',{staticClass:"content"},[_c('h1',{staticStyle:{"color":"white","margin-top":"90px","padding-left":"40px","width":"max-content"}},[_vm._v("PRODUCTO")])])]),_c('div',{staticClass:"producto-paragraph-container"},[_c('p',{staticClass:"paragraph"},[_vm._v(" Pantalla en construcción ")])])])
}]

export { render, staticRenderFns }